export const ATTACHMENT_LIST_FETCH_REQUEST = "ATTACHMENT_LIST_FETCH_REQUEST";
export const ATTACHMENT_LIST_FETCH_SUCCESS = "ATTACHMENT_LIST_FETCH_SUCCESS";
export const ATTACHMENT_LIST_FETCH_FAILURE = "ATTACHMENT_LIST_FETCH_FAILURE";
